import { render } from "./GARFIELD.vue?vue&type=template&id=1e83f3f4"
import script from "./GARFIELD.vue?vue&type=script&lang=js"
export * from "./GARFIELD.vue?vue&type=script&lang=js"

import "./GARFIELD.vue?vue&type=style&index=0&id=1e83f3f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__